import { createContext, useContext } from "react";

/**
 * Contesto ruolo utente corrente.
 *
 * Pattern isolato in un file dedicato (non in App.js) per evitare cicli di
 * import quando le pagine vogliono leggere il ruolo. App.js importa qui,
 * le pagine importano qui — nessuno importa da App.js.
 *
 * Forma del valore:
 *   { isAdmin: bool, nome: string|null, email: string|null, trovato: bool }
 *
 * Default sicuro: non-admin, utente non trovato.
 */
export const AUTH_DEFAULT = {
  isAdmin: false,
  nome: null,
  email: null,
  trovato: false,
};

export const AuthContext = createContext(AUTH_DEFAULT);

// Hook di comodo per le pagine:  const { isAdmin } = useAuth();
export const useAuth = () => useContext(AuthContext);
